var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 82.59 82.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3865ab;}.cls-2{fill:#84aff1;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 21.17,
    x2: 82.59,
    y2: 21.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.22,
    y: 19.61,
    width: 8,
    height: 62.89,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.78,
    y: 53.61,
    width: 8,
    height: 28.89,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.78,82.5h-6a1,1,0,0,1-1-1V71.61h8V81.5A1,1,0,0,1,8.78,82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.22,82.5h-6a1,1,0,0,1-1-1V46.61h8V81.5A1,1,0,0,1,80.22,82.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.93,
    y: 49.61,
    width: 8,
    height: 32.89,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.93,82.5h-6a1,1,0,0,1-1-1V64.61h8V81.5A1,1,0,0,1,65.93,82.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.64,
    y: 38.61,
    width: 8,
    height: 43.89,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.64,82.5h-6a1,1,0,0,1-1-1V75.61h8V81.5A1,1,0,0,1,51.64,82.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.36,
    y: 27.61,
    width: 8,
    height: 54.89,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.36,82.5h-6a1,1,0,0,1-1-1V42.61h8V81.5A1,1,0,0,1,37.36,82.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.07,
    y: 37.61,
    width: 8,
    height: 44.89,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.07,82.5h-6a1,1,0,0,1-1-1V55.61h8V81.5A1,1,0,0,1,23.07,82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2,42.33a2,2,0,0,1-1.44-.61,2,2,0,0,1,0-2.83l26-25a2,2,0,0,1,2.2-.39L54.56,25,79.18.58A2,2,0,0,1,82,3.42L56.41,28.75a2,2,0,0,1-2.22.41L28.42,17.71l-25,24.06A2,2,0,0,1,2,42.33Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLine);
export default __webpack_public_path__ + "static/media/icn-line.af9b161c1987fb1f0b031e2636e47a06.svg";
export { ForwardRef as ReactComponent };